var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 3.25H7.79078L7.74916 2.08489C7.72775 1.47956 7.23064 1 6.625 1H4.375C3.76936 1 3.27225 1.47956 3.25081 2.08489L3.20922 3.25H2.125C1.50372 3.25 1 3.75372 1 4.375V5.5C1 6.12128 1.50372 6.625 2.125 6.625H3.08867L2.72216 16.8872C2.36842 17.0768 2.125 17.4456 2.125 17.875C2.125 18.4963 2.62872 19 3.25 19H3.8125H7.1875H7.75C8.37128 19 8.875 18.4963 8.875 17.875C8.875 17.4456 8.63158 17.0768 8.27784 16.8872L7.91133 6.625H13.9375V7.78406C13.9375 7.90767 13.882 8.00875 13.8287 8.03484C12.8551 8.51053 12.25 9.47894 12.25 10.5625C12.25 12.0871 13.5379 13.375 15.0625 13.375C16.6132 13.375 17.875 12.1132 17.875 10.5625C17.875 9.9412 17.3713 9.43754 16.75 9.43754C16.1287 9.43754 15.625 9.9412 15.625 10.5625C15.625 10.8726 15.3726 11.125 15.0625 11.125C14.7733 11.125 14.5 10.8517 14.5 10.5625C14.5 10.3033 14.6634 10.1311 14.8167 10.0563C15.6494 9.649 16.1875 8.75715 16.1875 7.78406V6.625H17.875C18.4963 6.625 19 6.12128 19 5.5V4.375C19 3.75372 18.4963 3.25 17.875 3.25Z",
    stroke: "#118F84",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/CONSTRUCTION.1b554ca8aa709d24bf71337089c444c2.svg";
export { ForwardRef as ReactComponent };